import Vue from 'vue'
import { MLInstaller, MLCreate, MLanguage } from 'vue-multilanguage'
import {french} from './lang/french'
import {english} from './lang/english'

Vue.use(MLInstaller)
document.cookie = '';
let local = localStorage.getItem('vueml-lang');
if (local === 'english') {
  localStorage.setItem('vueml-lang', 'EN');
}
if (local === 'french') {
  localStorage.setItem('vueml-lang', 'FR');
}
export default new MLCreate({
  initial: 'EN',
  save: process.env.NODE_ENV === 'production',
  languages: [
    new MLanguage('EN').create(english),
    new MLanguage('FR').create(french)
  ]
})